// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import "../index.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setOpen(false);

  // Ferme le menu à chaque changement de page
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Empêche le scroll derrière le menu quand il est ouvert (mobile)
  useEffect(() => {
    document.body.classList.toggle("nav-open", open);
    return () => document.body.classList.remove("nav-open");
  }, [open]);

  return (
    <nav className="navbar nav-centered" role="navigation" aria-label="Navigation principale">
      {/* Logo centré (dimensions fixées pour éviter le CLS) */}
      <div className="navbar-logo-wrap">
        <Link to="/" className="navbar-logo" aria-label="Accueil" onClick={closeMenu}>
          <img
            src="/images/logo.png"
            alt="HLBK"
            width="120"              // ⬅️ mets ici les dimensions RÉELLES de ton logo
            height="120"
            decoding="async"
            fetchPriority="high"
          />
        </Link>
      </div>

      {/* Burger (mobile) */}
      <button
        className={`nav-burger ${open ? "is-open" : ""}`}
        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={open}
        aria-controls="navmenu"
        onClick={() => setOpen(v => !v)}
      >
        <span className="burger-bar" />
        <span className="burger-bar" />
        <span className="burger-bar" />
      </button>

      {/* Menu */}
      <div id="navmenu" className={`navbar-menu ${open ? "open" : ""}`}>
        <NavLink to="/galerie" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          Galerie
        </NavLink>
        <NavLink to="/services" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          Services
        </NavLink>
        <NavLink to="/about" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          À propos
        </NavLink>
        <NavLink to="/contact" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          Contact
        </NavLink>
        <NavLink to="/acces-clients" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : undefined)}>
          Accès clients
        </NavLink>
      </div>

      {/* Voile clicable derrière le menu (mobile) */}
      {open && <div className="nav-backdrop" onClick={closeMenu} aria-hidden="true" />}
    </nav>
  );
}